import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const AdWrapper = styled.div`
    border-radius: var(--radius-md);
    padding: 12px;
    border: 1px solid var(--line);
    display: inline-block;
    
    .alop {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 250px;
    }
`;

const Ad = () => {
    const adRef = useRef(null);

    useEffect(() => {
        if (!adRef.current) return;
        const adNode = adRef.current;

        // Create the first script to define atOptions
        const configScript = document.createElement("script");
        configScript.type = "text/javascript";
        configScript.innerHTML = `
            atOptions = {
                'key': '6962a0c71aa707b52f444c1a58b175ea',
                'format': 'iframe',
                'height': 250,
                'width': 300,
                'params': {}
            };
        `;
        adNode.appendChild(configScript);

        // Create the second script to load the ad
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://brijmohan.org/22/6962a0c71aa707b52f444c1a58b175ea";
        script.async = true;

        adNode.appendChild(script);

        return () => {
            // Cleanup: Remove scripts when component unmounts
            if (adNode.innerHTML) {
                adNode.innerHTML = "";
            }
        };
    }, []);

    return <AdWrapper><div ref={ adRef } className="alop"></div></AdWrapper>;
};

export default Ad;
